import { RegistroEntrenadorTitulo } from "../RegistroEntrenadorTitulo/RegistroEntrenadorTitulo";
import { RegistroEntrenadorAntiguedad } from "../RegistroEntrenadorAntiguedad/RegistroEntrenadorAntiguedad";
import { RegistroEntrenadorCurso } from "../RegistroEntrenadorCurso/RegistroEntrenadorCurso";
import { RegistroEntrenadorAntecedente } from "../RegistroEntrenadorAntecedente/RegistroEntrenadorAntecedente";
import { DateTime } from "luxon";

export interface RegistroEntrenadorJSON {
    re_id: string;
    re_apellido: string;
    re_nombre: string;
    re_documento_numero: string;
    re_dtid: string;
    re_documento_imagen: File | null;
    re_fecha_nacimiento: Date | null ;
    re_genero: string;
    re_domicilio: string;
    re_localidad: string;
    re_proid: number;
    re_cod_postal: string;
    re_tel_fijo: string;
    re_tel_movil: string;
    re_email: string;
    re_email_adicional: string;
    re_fed_id: number;
    re_foto: File | null;
    re_estado: string;
    re_otp_token: string;
    re_fecha_registro: Date;
    re_fecha_confirmacion: Date | null;
    re_fecha_activacion: Date | null;
    re_usid_activacion: string;
    tituloRegistroEntrenadorList: RegistroEntrenadorTitulo[],
    antiguedadRegistroEntrenadorList: RegistroEntrenadorAntiguedad[],
    cursoRegistroEntrenadorList: RegistroEntrenadorCurso[],
    antecedenteRegistroEntrenadorList: RegistroEntrenadorAntecedente[],
}

export class RegistroEntrenador {
    protected constructor(
    private id: string,
    private apellido: string,
    private nombre: string,
    private documentoNumero: string,
    private dtId: string,
    private documentoImagen: File | null,
    private fechaNacimiento: Date | null,
    private genero: string,
    private domicilio: string,
    private localidad: string,
    private proid: number,
    private codPostal: string,
    private telFijo: string,
    private telMovil: string,
    private email: string,
    private emailAdicional: string,
    private fedId: number,
    private foto: File | null,
    private estado: string,
    private otpToken: string,
    private fechaRegistro: Date,
    private fechaConfirmacion: Date | null,
    private fechaActivacion: Date | null,
    private usidActivacion: string,
    private tituloRegistroEntrenadorList: RegistroEntrenadorTitulo[],
    private antiguedadRegistroEntrenadorList: RegistroEntrenadorAntiguedad[],
    private cursoRegistroEntrenadorList: RegistroEntrenadorCurso[],
    private antecedenteRegistroEntrenadorList: RegistroEntrenadorAntecedente[]
) {}

    static createFrom( id: string,
    apellido: string,
    nombre: string,
    documentoNumero: string,
    dtId: string,
    documentoImagen: File | null,
    fechaNacimiento: Date | null,
    genero: string,
    domicilio: string,
    localidad: string,
    proid: number,
    codPostal: string,
    telFijo: string,
    telMovil: string,
    email: string,
    emailAdicional: string,
    fedId: number,
    foto: File | null,
    estado: string,
    otpToken: string,
    fechaRegistro: Date,
    fechaConfirmacion: Date | null,
    fechaActivacion: Date | null,
    usidActivacion: string,
    tituloRegistroEntrenadorList: RegistroEntrenadorTitulo[],
    antiguedadRegistroEntrenadorList: RegistroEntrenadorAntiguedad[],
    cursoRegistroEntrenadorList: RegistroEntrenadorCurso[],
    antecedenteRegistroEntrenadorList: RegistroEntrenadorAntecedente[]
  ) {
        return new this( id,
        apellido,
        nombre,
        documentoNumero,
        dtId,
        documentoImagen,
        fechaNacimiento,
        genero,
        domicilio,
        localidad,
        proid,
        codPostal,
        telFijo,
        telMovil,
        email,
        emailAdicional,
        fedId,
        foto,
        estado,
        otpToken,
        fechaRegistro,
        fechaConfirmacion,
        fechaActivacion,
        usidActivacion,
        tituloRegistroEntrenadorList,
        antiguedadRegistroEntrenadorList,
        cursoRegistroEntrenadorList,
        antecedenteRegistroEntrenadorList)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: RegistroEntrenador) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: RegistroEntrenadorJSON) {
        return RegistroEntrenador.createFrom( entity.re_id,
        entity.re_apellido,
        entity.re_nombre,
        entity.re_documento_numero,
        entity.re_dtid,
        entity.re_documento_imagen,
        entity.re_fecha_nacimiento ? new Date(entity.re_fecha_nacimiento) : null,
        entity.re_genero,
        entity.re_domicilio,
        entity.re_localidad,
        entity.re_proid,
        entity.re_cod_postal,
        entity.re_tel_fijo,
        entity.re_tel_movil,
        entity.re_email,
        entity.re_email_adicional,
        entity.re_fed_id,
        entity.re_foto,
        entity.re_estado,
        entity.re_otp_token,
        entity.re_fecha_registro,
        entity.re_fecha_confirmacion ? new Date(entity.re_fecha_confirmacion) : null,
        entity.re_fecha_activacion ? new Date(entity.re_fecha_activacion) : null,
        entity.re_usid_activacion,
        entity.tituloRegistroEntrenadorList,
        entity.antiguedadRegistroEntrenadorList,
        entity.cursoRegistroEntrenadorList,
        entity.antecedenteRegistroEntrenadorList
      )
    }

    toJSON(): RegistroEntrenadorJSON {
        return {
            re_id: this.getId(),
            re_apellido: this.getApellido(),
            re_nombre: this.getNombre(),
            re_documento_numero: this.getDocumentoNumero(),
            re_dtid: this.getDtid(),
            re_documento_imagen: this.getDocumentoImagen(),
            re_fecha_nacimiento: this.getFechaNacimiento(),
            re_genero: this.getGenero(),
            re_domicilio: this.getDomicilio(),
            re_localidad: this.getLocalidad(),
            re_proid: this.getProid(),
            re_cod_postal: this.getCodPostal(),
            re_tel_fijo: this.getTelFijo(),
            re_tel_movil: this.getTelMovil(),
            re_email: this.getEmail(),
            re_email_adicional: this.getEmailAdicional(),
            re_fed_id: this.getFedId(),
            re_foto: this.getFoto(),
            re_estado: this.getEstado(),
            re_otp_token: this.getOtpToken(),
            re_fecha_registro: this.getFechaRegistro(),
            re_fecha_confirmacion: this.getFechaConfirmacion(),
            re_fecha_activacion: this.getFechaActivacion(),
            re_usid_activacion: this.getUsidActivacion(),
            tituloRegistroEntrenadorList: this.getRegistroEntrenadorTituloList(),
            antiguedadRegistroEntrenadorList: this.getRegistroEntrenadorAntiguedadList(),
            cursoRegistroEntrenadorList: this.getRegistroEntrenadorCursoList(),
            antecedenteRegistroEntrenadorList: this.getRegistroEntrenadorAntecedenteList()
        }

    }

    getId(): string { return this.id; }

    getApellido(): string { return this.apellido; }

    getNombre(): string { return this.nombre; }

    getDocumentoNumero(): string { return this.documentoNumero; }

    getDtid(): string { return this.dtId; }

    getDocumentoImagen(): File | null { return this.documentoImagen; }

    getFechaNacimiento(): Date | null { return this.fechaNacimiento; }

    getGenero(): string { return this.genero; }

    getDomicilio(): string { return this.domicilio; }

    getLocalidad(): string { return this.localidad; }

    getProid(): number { return this.proid; }

    getCodPostal(): string { return this.codPostal; }

    getTelFijo(): string { return this.telFijo; }

    getTelMovil(): string { return this.telMovil; }

    getEmail(): string { return this.email; }

    getEmailAdicional(): string { return this.emailAdicional; }

    getFedId(): number { return this.fedId; }

    getFoto(): File | null { return this.foto; }

    getEstado(): string { return this.estado; }

    getOtpToken(): string { return this.otpToken; }

    getFechaRegistro(): Date { return this.fechaRegistro; }

    getFechaConfirmacion(): Date | null { return this.fechaConfirmacion; }

    getFechaActivacion(): Date | null { return this.fechaActivacion; }

    getUsidActivacion(): string { return this.usidActivacion; }

    getRegistroEntrenadorTituloList(): RegistroEntrenadorTitulo[] { return this.tituloRegistroEntrenadorList; }

    getRegistroEntrenadorAntiguedadList(): RegistroEntrenadorAntiguedad[] { return this.antiguedadRegistroEntrenadorList; }

    getRegistroEntrenadorCursoList(): RegistroEntrenadorCurso[] { return this.cursoRegistroEntrenadorList; }

    getRegistroEntrenadorAntecedenteList(): RegistroEntrenadorAntecedente[] { return this.antecedenteRegistroEntrenadorList; }

}

